module.exports = __webpack_public_path__ + "img/FullbackLight3.5ab3a28e.jpg";